// UW-Madison's undergraduate majors (#2748). Read on 2026-10-01 from the
// official Guide (guide.wisc.edu/undergraduate, "Majors and Certificates"),
// which links every program to the school or college that offers it and
// names its degree: every bachelor's line kept (BA, BS, BBA, BFA, BSE, BM,
// BSN, BSW, BLS, BLA, BNS, JBA, JBS), certificates left out. The Gaylord
// Nelson Institute's Environmental Studies major is an additional major,
// earned only alongside another, so it is left out. Degrees are written as
// the Guide writes them, including "BA (L&S)" and "BS (CALS)" where Letters
// & Science and Agricultural and Life Sciences both offer a major, and the
// Nursing BSN's accelerated and collaborative programs. The Guide's
// en dash in "Astronomy-Physics" is a hyphen here. The KB's majors list was
// the starting point; the Guide wins.
const majors = {
    "slug": "university-of-wisconsin-madison",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UW-Madison's official Guide (the undergraduate catalog), grouped by the school or college that offers it, with the degree it leads to. Certificates, the Environmental Studies additional major and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural and Life Sciences",
            "source": {
                "label": "UW-Madison Guide 2026-2027, College of Agricultural and Life Sciences",
                "url": "https://guide.wisc.edu/undergraduate/agricultural-life-sciences/"
            },
            "majors": [
                {
                    "name": "Agricultural and Applied Economics",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Business Management",
                    "degree": "BS"
                },
                {
                    "name": "Agroecology",
                    "degree": "BS"
                },
                {
                    "name": "Agronomy",
                    "degree": "BS"
                },
                {
                    "name": "Animal and Veterinary Biosciences",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS (CALS)"
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS (CALS)"
                },
                {
                    "name": "Community and Environmental Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Dairy and Food Animal Management",
                    "degree": "BS"
                },
                {
                    "name": "Dairy Science",
                    "degree": "BS"
                },
                {
                    "name": "Entomology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS (CALS)"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Forest Science",
                    "degree": "BS"
                },
                {
                    "name": "Genetics and Genomics",
                    "degree": "BS"
                },
                {
                    "name": "Global Health",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Individual Major",
                    "degree": "BS"
                },
                {
                    "name": "Life Sciences Communication",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS (CALS)"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS Nutrition and Dietetics"
                },
                {
                    "name": "Plant Pathology",
                    "degree": "BS"
                },
                {
                    "name": "Plant Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Soil Science",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife Ecology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UW-Madison Guide 2026-2027, College of Engineering",
                "url": "https://guide.wisc.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Mechanics",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Naval Science",
                    "degree": "BNS"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Letters & Science",
            "source": {
                "label": "UW-Madison Guide 2026-2027, College of Letters & Science",
                "url": "https://guide.wisc.edu/undergraduate/letters-science/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "African American Studies",
                    "degree": "BS"
                },
                {
                    "name": "African Cultural Studies",
                    "degree": "BA"
                },
                {
                    "name": "African Cultural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics, Engineering, and Physics",
                    "degree": "BS AMEP"
                },
                {
                    "name": "Applied Social Science",
                    "degree": "BLS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BS"
                },
                {
                    "name": "Asian Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Asian Languages and Cultures",
                    "degree": "BS"
                },
                {
                    "name": "Astronomy-Physics",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy-Physics",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA (L&S)"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS (L&S)"
                },
                {
                    "name": "Biology",
                    "degree": "BA (L&S)"
                },
                {
                    "name": "Biology",
                    "degree": "BS (L&S)"
                },
                {
                    "name": "Botany",
                    "degree": "BA"
                },
                {
                    "name": "Botany",
                    "degree": "BS"
                },
                {
                    "name": "Cartography and Geographic Information Systems",
                    "degree": "BA"
                },
                {
                    "name": "Cartography and Geographic Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chicanx/e and Latinx/e Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chicanx/e and Latinx/e Studies",
                    "degree": "BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BS"
                },
                {
                    "name": "Classical Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Classical Humanities",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BS"
                },
                {
                    "name": "Communication Arts",
                    "degree": "BA"
                },
                {
                    "name": "Communication Arts",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BA"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Computer Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Computer Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Conservation Biology",
                    "degree": "BA"
                },
                {
                    "name": "Conservation Biology",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BA (L&S)"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS (L&S)"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BS"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology and Geophysics",
                    "degree": "BA"
                },
                {
                    "name": "Geology and Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "Individual Major",
                    "degree": "BA"
                },
                {
                    "name": "Individual Major",
                    "degree": "BS"
                },
                {
                    "name": "Information Science",
                    "degree": "BA"
                },
                {
                    "name": "Information Science",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BS"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BS"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BS"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "JBA"
                },
                {
                    "name": "Journalism",
                    "degree": "JBS"
                },
                {
                    "name": "Korean Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Korean Language and Culture",
                    "degree": "BS"
                },
                {
                    "name": "Landscape and Urban Studies",
                    "degree": "BA"
                },
                {
                    "name": "Landscape and Urban Studies",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Latin American, Caribbean, and Iberian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American, Caribbean, and Iberian Studies",
                    "degree": "BS"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BS"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BS"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BA (L&S)"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS (L&S)"
                },
                {
                    "name": "Molecular and Cell Biology",
                    "degree": "BA"
                },
                {
                    "name": "Molecular and Cell Biology",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Music: Education",
                    "degree": "BM"
                },
                {
                    "name": "Music: Performance",
                    "degree": "BM"
                },
                {
                    "name": "Neurobiology",
                    "degree": "BA"
                },
                {
                    "name": "Neurobiology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Polish",
                    "degree": "BA"
                },
                {
                    "name": "Polish",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Portuguese",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BS"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BS"
                },
                {
                    "name": "Scandinavian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Scandinavian Studies",
                    "degree": "BS"
                },
                {
                    "name": "Social Welfare",
                    "degree": "BA"
                },
                {
                    "name": "Social Welfare",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Zoology",
                    "degree": "BA"
                },
                {
                    "name": "Zoology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "UW-Madison Guide 2026-2027, School of Business",
                "url": "https://guide.wisc.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Business Administration: Human Resources",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration: Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration: Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Actuarial Science",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Finance, Investment, and Banking",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Business: International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Management and Human Resources",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Operations and Technology Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Real Estate and Urban Land Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Risk Management and Insurance",
                    "degree": "BBA"
                },
                {
                    "name": "Business: Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "UW-Madison Guide 2026-2027, School of Education",
                "url": "https://guide.wisc.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Art Education",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art",
                    "degree": "BS"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Dance",
                    "degree": "BS"
                },
                {
                    "name": "Educational Policy Studies",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education and Special Education",
                    "degree": "BSE"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSE"
                },
                {
                    "name": "Health Promotion and Health Equity",
                    "degree": "BS"
                },
                {
                    "name": "Individual Major",
                    "degree": "BSE"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BS"
                },
                {
                    "name": "Rehabilitation Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Special Education",
                    "degree": "BSE"
                },
                {
                    "name": "Theatre and Drama",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Human Ecology",
            "source": {
                "label": "UW-Madison Guide 2026-2027, School of Human Ecology",
                "url": "https://guide.wisc.edu/undergraduate/human-ecology/"
            },
            "majors": [
                {
                    "name": "Community and Organizational Development",
                    "degree": "BS"
                },
                {
                    "name": "Consumer Behavior and Marketplace Studies",
                    "degree": "BS"
                },
                {
                    "name": "Consumer Finance and Financial Planning",
                    "degree": "BS"
                },
                {
                    "name": "Consumer Marketplace Studies",
                    "degree": "BS"
                },
                {
                    "name": "Design, Innovation, and Society",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "BS"
                },
                {
                    "name": "Individual Major",
                    "degree": "BS"
                },
                {
                    "name": "Interior Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Personal Finance",
                    "degree": "BS"
                },
                {
                    "name": "Textiles and Fashion Design",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UW-Madison Guide 2026-2027, School of Nursing",
                "url": "https://guide.wisc.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN (Accelerated Program)"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN (Collaborative Program)"
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "UW-Madison Guide 2026-2027, School of Pharmacy",
                "url": "https://guide.wisc.edu/undergraduate/pharmacy/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Pharmacology and Toxicology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
